(function(w, $, _) {

    const assetId = '~/Parts/Views/QuickBuy/QuickBuy_Base.min.js';

    if (!w.umwAssets || !w.umwAssets[assetId]) {
        console.error('No context found for ' + assetId);
        return;
    }

    if (w.umwAssets[assetId].length > 1) {
        console.error('More than one context was defined for ' + assetId + ', ony one is supported.');
    }

    const ctx = w.umwAssets[assetId][0];

    $(function () {
        var context = ctx.quickBuyContext;
        var includeCartInfoToQuickBuy = ctx.includeCartInfoToQuickBuy;
        var $mainPanel = $('.js-UC173MainContainer');
        var $productName = $mainPanel.find('#' + context.fieldIds.productFullNameID);
        var $quantity = $mainPanel.find('#' + context.fieldIds.quantityId);
        var $btnQtyMinus = $mainPanel.find('#' + context.fieldIds.btnQtyMinusId);
        var $btnQtyPlus = $mainPanel.find('#' + context.fieldIds.btnQtyPlusId);
        var $buyButton = $mainPanel.find('#' + context.fieldIds.buyButtonId);
        var $errMsg = $mainPanel.find('#quickBuyError');
        var selectedItem;
        var searchTerm;

        $quantity.val('1');
        $productName.focus();

        $quantity.numeric({
            negative: false,
            decimal: ','
        });

        $buyButton.bind('click',
            function(e) {
                e.preventDefault();
                _validateAndTryBuy();
            });

        $quantity.bind('keyup',
            function(e) {
                if (e.keyCode === $.ui.keyCode.ENTER) {
                    e.preventDefault();
                    _validateAndTryBuy();
                }
                if (e.keyCode === 40) {
                    e.preventDefault();
                    $btnQtyMinus.click();
                }
                if (event.keyCode === 38) {
                    e.preventDefault();
                    $btnQtyPlus.click();
                }
            });

        $btnQtyMinus.on('click', function() {
            var quantity = $.mw_tryParseIntStrict($quantity.val());
            if (!isNaN(quantity) && quantity > 0) {
                $quantity.val(--quantity);
            }
        });

        $btnQtyPlus.on('click',
            function() {
                var quantity = $.mw_tryParseIntStrict($quantity.val());
                if (!isNaN(quantity)) {
                    $quantity.val(++quantity);
                }
            });

        $productName.autocomplete({
            source: function(request, response) {
                $.publicFetch({
                    handler: 'ProductData',
                    data: {
                        action: 'GetProductListAutocomplete',
                        q: request.term
                    },
                    success: function(result) {
                        searchTerm = request.term;
                        if (result) {
                            var map = _.map(result,
                                function(currentItem) {
                                    currentItem.label = currentItem.value + ' - ' + currentItem.label;
                                    return currentItem;
                                });
                            response(map);
                        }
                    },
                    error: function (err) {
                        w.PubSub.publish('notification.error', err.Message);
                    }
                });
            },
            create: function (event, ui) {
                $(this).autocomplete('instance')._renderItem = function (ul, item) {
                    ul.addClass('umw-quick-buy-autocomplete-popup');
                    var $li = $('<li/>').data('item.autocomplete', item);

                    if (context.options.showProductImages) {
                        $li.append("<img src='" + item.imageUrl + "' class=umw-quick-buy-autocomplete-popup__term-image />");
                    }
                    var $divFragment = $('<div class="umw-quick-buy-autocomplete-popup__term-description"/>').append('<div class=umw-quick-buy-autocomplete-popup__term-name>' + item.label + '</div>');

                    if (includeCartInfoToQuickBuy && item.qtyInCart) {
                        $divFragment.append('<div class="umw-quick-buy-autocomplete-popup__product-in-cart badge">' + item.qtyInCart + ' ' + context.labels.inCart + '</div>');
                        $li.addClass('product-in-cart');
                    }
                    $li.append($divFragment);

                    $li.appendTo(ul);
                    return $li;
                }
            },
            search: function() {
                return this.value.length > 2;
            },
            select: function(event, ui) {
                event.preventDefault();
                $productName.val(ui.item.label);
                selectedItem = ui.item;
            },
            focus: function(e) {
                e.preventDefault();
            }
        });

        $productName.focus(function () {
            _tryResearch();
        });

        function _tryResearch() {
            if (searchTerm) {
                $productName.val(searchTerm);
                $productName.autocomplete('search', searchTerm);
            }
        };

        function _validateAndTryBuy() {
            var quantityVal = parseFloat($quantity.val().replace(',', '.'));

            if (!selectedItem) {
                $errMsg.addClass('show').html(context.errorMessages.noProduct);
                return;
            }

            if (quantityVal <= 0) {
                $errMsg.addClass('show').html(context.errorMessages.noQuantity);
                return;
            }

            if (quantityVal < selectedItem.minQuantity) {
                $errMsg.addClass('show').html(context.errorMessages.minQuantity + ' ' + selectedItem.minQuantity);
                return;
            }

            if (selectedItem.isSingleQuantityUnit === true && quantityVal % 1 != 0) {
                $errMsg.addClass('show').html(context.labels.singleQuantity);
                return;
            }

            $errMsg.removeClass('show');
            var contract = { productId: selectedItem.id, quantity: quantityVal };
            _blockUI();
            $.when(w.PublicEStore.addToCart(contract)).then(_successCallback, _errorCallback).always(_unblockUI);
        }

        function _successCallback() {
            $productName.val(searchTerm).select();
        }

        function _errorCallback(errorContract) {
            if (errorContract) {
                var errorMessage;
                if (typeof errorContract === 'string') {
                    errorMessage = errorContract;
                } else {
                    errorMessage = errorContract.result && errorContract.result.items[0]
                        ? errorContract.result.items[0].message
                        : errorContract.message;
                }

                $errMsg.addClass('show').html(errorMessage);
            }
        }

        function _blockUI() {
            if (typeof ($.blockUI) === 'function') {
                $mainPanel.block({ message: null });
            }
        }

        function _unblockUI() {
            if (typeof ($.unblockUI) === 'function') {
                $mainPanel.unblock();
            }
        }
    });
})(window, jQuery, _);